import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b915dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "control" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Columns", -1))
const _hoisted_3 = { class: "control" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Columns", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "is-hidden-tablet" }, null, -1))
const _hoisted_6 = { class: "modal-card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "modal-card-head" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Column Selection")
], -1))
const _hoisted_8 = { class: "modal-card-body" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "Current View", -1))
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "columns is-multiline" }
const _hoisted_12 = { class: "column is-half" }
const _hoisted_13 = { class: "modal-card-foot" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Reset to Defaults")


import CsvDownload from "./CsvDownload.vue";
import SearchControls from "../Search/Component.vue";
import NewPagination from "../../Breakdown/NewPagination.vue";
import ColumnSet from "../../Pieces/ColumnSet.vue";
import ComparisonDates from "../../Pieces/ComparisonDates.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

const __default__ = {
  components: {
    ColumnSet,
    NewPagination,
    CsvDownload,
    SearchControls,
    VueCtkDateTimePicker,
    ComparisonDates,
  },
};
import { UsePerformanceTableControls } from "./Hooks/UsePerformanceTableControls";
import { UsePerformanceTable } from "./Hooks/UsePerformanceTable";
import { PerformanceTableAndChartData } from "../../../Helper/Stateful/PerformanceTableAndChartData";
import { UseTaxonomyHelper } from "../../../Helper/Stateful/UseTaxonomyHelper";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { isColumnModalActive, setDefaultColumns } = UsePerformanceTableControls();
const { tableHeaders: headers } = PerformanceTableAndChartData();
const { taxonomyTwo } = UseTaxonomyHelper();

const {
  columnsCompute,
  pageCompute,
  perPageCompute,
  recordsCompute,
  availableColumnsChunked,
} = UsePerformanceTable();

const closeModal = () => {
  isColumnModalActive.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_checkbox = _resolveComponent("o-checkbox")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_modal = _resolveComponent("o-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_o_field, {
      grouped: "",
      class: "is-hidden-mobile",
      "group-multiline": ""
    }, {
      default: _withCtx(() => [
        _createVNode(SearchControls),
        _createVNode(_component_o_field, null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "export"),
            _createElementVNode("p", _hoisted_1, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isColumnModalActive.value = true))
              }, [
                _createVNode(_component_o_icon, { icon: "table-row-height" }),
                _hoisted_2
              ])
            ])
          ]),
          _: 3
        }),
        _createVNode(ComparisonDates),
        (_unref(taxonomyTwo) !== undefined)
          ? (_openBlock(), _createBlock(NewPagination, {
              key: 0,
              page: _unref(pageCompute),
              "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageCompute) ? (pageCompute).value = $event : null)),
              "per-page": _unref(perPageCompute),
              "onUpdate:per-page": _cache[2] || (_cache[2] = ($event: any) => (_isRef(perPageCompute) ? (perPageCompute).value = $event : null)),
              records: _unref(recordsCompute),
              "onUpdate:records": _cache[3] || (_cache[3] = ($event: any) => (_isRef(recordsCompute) ? (recordsCompute).value = $event : null))
            }, null, 8, ["page", "per-page", "records"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode(_component_o_field, { class: "is-hidden-tablet" }, {
      default: _withCtx(() => [
        _createVNode(SearchControls, { "is-mobile": "" })
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, {
      grouped: "",
      class: "is-hidden-tablet"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "export"),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (isColumnModalActive.value = true))
              }, [
                _createVNode(_component_o_icon, { icon: "table-row-height" }),
                _hoisted_4
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _createVNode(_component_o_field, {
      grouped: "",
      class: "is-hidden-tablet"
    }, {
      default: _withCtx(() => [
        _createVNode(ComparisonDates)
      ]),
      _: 1
    }),
    _createVNode(_component_o_field, { class: "is-hidden-tablet" }, {
      default: _withCtx(() => [
        (_unref(taxonomyTwo) !== undefined)
          ? (_openBlock(), _createBlock(NewPagination, {
              key: 0,
              page: _unref(pageCompute),
              "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageCompute) ? (pageCompute).value = $event : null)),
              "per-page": _unref(perPageCompute),
              "onUpdate:per-page": _cache[6] || (_cache[6] = ($event: any) => (_isRef(perPageCompute) ? (perPageCompute).value = $event : null)),
              records: _unref(recordsCompute),
              "onUpdate:records": _cache[7] || (_cache[7] = ($event: any) => (_isRef(recordsCompute) ? (recordsCompute).value = $event : null))
            }, null, 8, ["page", "per-page", "records"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_5,
    _createElementVNode("section", null, [
      _createVNode(_component_o_modal, {
        active: _unref(isColumnModalActive),
        "onUpdate:active": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isColumnModalActive) ? (isColumnModalActive).value = $event : null)),
        "has-modal-card": "",
        ref: "columnModal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("section", _hoisted_8, [
              _hoisted_9,
              _createVNode(ColumnSet),
              _createElementVNode("p", _hoisted_10, _toDisplayString("Selected Columns (" + _unref(columnsCompute).length + ")"), 1),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableColumnsChunked), (column) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_o_checkbox, {
                      modelValue: _unref(columnsCompute),
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(columnsCompute) ? (columnsCompute).value = $event : null)),
                      "native-value": column
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(headers) ? _unref(headers)[column] : column), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "native-value"])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("footer", _hoisted_13, [
              _createVNode(_component_o_button, {
                class: "button is-primary",
                onClick: closeModal,
                variant: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_o_button, {
                class: "button",
                onClick: _unref(setDefaultColumns),
                "icon-left": "restart"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ]))
}
}

})